
export class GetPlanogramSharedUsersRequest {
  planogramId: string = '';

  constructor(planogramId: string) {
    this.planogramId = planogramId;
  }
}
